import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css"; 
import App from "./App"; 

const queryClient = new QueryClient();

const renderApp = () => {
    const rootElement = document.getElementById("root");
    if (rootElement) {
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <QueryClientProvider client={queryClient}>
                    <App />
                </QueryClientProvider>
            </React.StrictMode>
        );
    }
};

// Check if DOM is already ready
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderApp);
} else {
    renderApp();
}
